import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'packages/theming';
import { defineMessages, FormattedMessage } from 'react-intl';
import { Box, constants, Text } from '@match/react-component-library';
import { buildUrl } from 'modules/utils/url';
import { Topic } from 'types';

const { SPACE, TYPOGRAPHY } = constants;

export interface SearchResults {
  answers: Topic[];
  searchString: string;
}

function Results({ answers, searchString }: SearchResults) {
  return (
    <Box paddingLeft={SPACE.XXXLARGE}>
      <Text as="h1" typography={TYPOGRAPHY.HEADING4}>
        <FormattedMessage {...messages.searchResultsTitle} />
        &nbsp;"{searchString}"
      </Text>
      <Box as="ul" marginTop={SPACE.LARGE}>
        {answers.map((answer: Topic) => {
          return (
            <Box key={answer.id} as="li" marginBottom={SPACE.MEDIUM} minWidth="50%">
              <StyledLink to={buildUrl(String(answer.categoryId), String(answer.id))}>
                <Text typography={TYPOGRAPHY.LARGE_BODY}>{answer.title}</Text>
              </StyledLink>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}

export default Results;

const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.dark,
  ':hover': {
    textDecoration: 'none',
  },
  ':visited': {
    color: theme.palette.dark,
    textDecoration: 'none',
  },
}));

const messages = defineMessages({
  searchResultsTitle: {
    id: 'src/modules/components/SearchResults/components/Results:searchResultsTitle',
    description: 'header for search results page',
    defaultMessage: 'Results for:',
  },
});
